// Shared AntD token defaults. Industry token files spread these and override as needed.

export const baseTokens = {
  token: {
    colorPrimary: '#1B5E20',
    colorInfo: '#1B5E20',
    colorLink: '#1B5E20',
    colorPrimaryHover: '#164e1a',
    colorLinkHover: '#164e1a',
    colorPrimaryActive: '#123f15',
    colorSuccess: '#00a76f',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorTextBase: '#0f172a',
    colorText: '#0f172a',
    colorTextHeading: '#111827',
    colorTextSecondary: 'rgba(15, 23, 42, 0.68)',
    colorTextTertiary: 'rgba(15, 23, 42, 0.48)',
    colorBgBase: '#ffffff',
    colorBgLayout: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorFillAlter: '#f9fafb',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#eef1f4',
    borderRadius: 8,
    borderRadiusLG: 8,
    borderRadiusSM: 6,
    controlHeight: 40,
    controlHeightLG: 46,
    controlHeightSM: 32,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    Button: {
      borderRadius: 6,
      controlHeight: 38,
      controlHeightLG: 44,
      fontWeight: 700,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      borderRadiusLG: 8,
      colorBorderSecondary: '#eef1f4',
      boxShadowTertiary: '0 0.5rem 1.5rem rgba(15, 23, 42, 0.06)',
    },
    Input: {
      borderRadius: 6,
      controlHeight: 40,
      activeBorderColor: '#1B5E20',
      hoverBorderColor: '#1B5E20',
      activeShadow: '0 0 0 3px rgba(27, 94, 32, 0.16)',
    },
    InputNumber: {
      borderRadius: 6,
      controlHeight: 40,
      activeBorderColor: '#1B5E20',
      hoverBorderColor: '#1B5E20',
      activeShadow: '0 0 0 3px rgba(27, 94, 32, 0.16)',
    },
    Select: {
      borderRadius: 6,
      controlHeight: 40,
      optionSelectedBg: '#E6F2E6',
      optionSelectedColor: '#1B5E20',
    },
    Menu: {
      itemBorderRadius: 6,
      itemSelectedBg: '#E6F2E6',
      itemSelectedColor: '#1B5E20',
      itemHoverBg: '#E6F2E6',
    },
    Pagination: {
      itemActiveBg: '#E6F2E6',
      colorPrimary: '#1B5E20',
      colorPrimaryHover: '#164e1a',
      colorPrimaryActive: '#123f15',
    },
    Modal: {
      borderRadiusLG: 8,
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
};
